import ReportingFilter from "components/reportingFilter/ReportingFilter";
import React from "react";
import styles from "./messagePerformance.module.scss";
import ReportingExport from "components/reportingExport/ReportingExport";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { type ConnectedProps, connect } from "react-redux";
import { useAccountFilterShouldShow } from "features/Reporting/Content/queries/useAccountFilterShouldShow";
import { usePerformanceFilter } from "features/Library/Common/Hooks/usePerformanceFilter";
import { usePerformanceBreadcrumbs } from "features/Library/Common/Hooks/usePerformanceBreadcrumbs";
import MessagePerformanceBody from "./MessagePerformanceBody";
import cn from "classnames";
import { FeatureFlags } from "featureFlags";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";

export type Props = PropsFromRedux & {
  messageId: number;
  messageName: string;
};

export const MessagePerformance: React.FC<Props> = ({
  messageId,
  messageName,
  accountId,
  accountType,
  associatedFlows,
}) => {
  const isReportEnabled = useFeatureFlag(FeatureFlags.MessageReport);
  const accountFilterShouldShow = useAccountFilterShouldShow(accountId, accountType, true);
  const [filter, setFilter] = usePerformanceFilter({
    includeAccountsDropdown: accountFilterShouldShow,
    accountId,
    includeDistinct: true,
    supportsSPType: true,
    includeFlows: associatedFlows !== undefined && associatedFlows.length > 0,
  });

  const { domElements, registerBreadcrumb, hasBreadcrumbsToDisplay } = usePerformanceBreadcrumbs();

  if (!isReportEnabled) {
    return <ReportUnavailable />;
  }

  return (
    <div className="performanceRoot">
      <div className="performanceHeader">
        <div className={cn("performanceHeader", styles.header)}>
          {hasBreadcrumbsToDisplay ? <div>{domElements}</div> : <h2 className="performanceTitle">Summary</h2>}
          <div className="performanceActions">
            <ReportingFilter
              currentFilter={filter}
              callback={setFilter}
              includeAccountsDropdown={accountFilterShouldShow}
              includeAccounts={false}
              includeDistinct
              ignoreInCountAndHide={["type"]}
              supportsSPType
              flowsData={associatedFlows}
            />
            <ReportingExport />
          </div>
        </div>
      </div>
      <MessagePerformanceBody
        messageName={messageName}
        filter={filter}
        messageId={messageId}
        includeAccounts={!!filter.accounts?.length}
        registerBreadcrumb={registerBreadcrumb}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    accountId: state.userProfile.accountId,
    accountType: state.userProfile.accountTypeId,
    associatedFlows: state.library.messages.details.values.flows,
  };
};

const mapDispatchToProps = (_dispatch: AppDispatch) => ({});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedMessagePerformance = connector(MessagePerformance);
export default ConnectedMessagePerformance;
